const initialState = {
  list: [],
  pagination: { page: 1, perPage: 20, total: 0 },
};

const mutations = {
  SET_DATA(state, { key, data }) {
    state[key] = data;
  },
  INIT_STATE(state) {
    state.list = initialState.list;
    state.pagination = initialState.pagination;
  },
  UPSERT_MEETING(state, meeting) {
    const existsIndex = state.meetings.findIndex((item) => item.id === meeting.id);
    if (existsIndex !== -1) {
      state.meetings.splice(existsIndex, 1, meeting);
    } else {
      state.meetings.unshift(meeting);
    }
  },
  REMOVE_MEETING(state, id) {
    state.meetings = state.meetings.filter((meeting) => meeting.id !== id);
    state.list = state.list.filter((meeting) => meeting.id !== id);
    delete state.guestsByMeeting[id];
    if (state.currentMeeting?.id === id) {
      state.currentMeeting = null;
      state.currentGuests = [];
    }
  },
  UPSERT_GUESTS(state, { meetingId, guests }) {
    state.guestsByMeeting = {
      ...state.guestsByMeeting,
      [meetingId]: guests,
    };

    if (state.currentMeeting?.id === meetingId) {
      state.currentGuests = guests;
    }
  },
};

export default mutations;
